export default "__VITE_ASSET__0ecf1427__"